import { ContractHistory } from "@/types/reward";
import * as userRequest from "@/utils/userRequest";

export default async function getContractHistory(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("/user/history-signature", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ getContractHistory ~ res:", res);

        if (res) {
            const data: ContractHistory[] = res?.data?.map?.((item: any) => ({
                id: item?.id,
                date_created: item?.date_created,
                signature: item?.signature,
                rank_id: item?.rank_id,
                user_id: item?.user_id,
                title: item?.title,
            }));
            console.log("🚀 ~ getContractHistory ~ data:", data);
            onSuccess && onSuccess(data);
            return data;
        }
    } catch (err) {
        console.error("🚀 ~ getContractHistory ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}

export async function getContractHistoryDetail(token: string, id: string) {
    const res = await userRequest.get(`/user/fetch-signature/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    console.log("🚀 ~ getContractHistoryDetail ~ res:", res);
    return res;
}
